import { Constants, Events, Order } from '../Contract';
import { Inject } from './Inject';
var DeltaHandler = (function () {
    function DeltaHandler(inject) {
        if (inject === void 0) { inject = null; }
        this.inject = inject;
        this.inject = inject ? inject : Inject.Instance;
        this.event = this.inject.resolve(Constants.EventAggregator);
        this.preWorkers = [];
        this.workers = [];
        this.postWorkers = [];
    }
    DeltaHandler.prototype.registerWorker = function (worker) {
        if (worker) {
            var selectedArray = void 0;
            switch (worker.Order) {
                case Order.PRE:
                    selectedArray = this.preWorkers;
                    break;
                case Order.ORD:
                    selectedArray = this.workers;
                    break;
                case Order.POST:
                    selectedArray = this.postWorkers;
                    break;
            }
            if (selectedArray.indexOf(worker) === -1) {
                selectedArray.push(worker);
            }
        }
    };
    DeltaHandler.prototype.executeWorkers = function (response) {
        this.preWorkers.forEach(function (worker) {
            worker.process(response);
        });
        this.workers.forEach(function (worker) {
            worker.process(response);
        });
        this.postWorkers.forEach(function (worker) {
            worker.process(response);
        });
        this.event.publish(Events.ExecWorkQueue);
    };
    return DeltaHandler;
}());
export { DeltaHandler };
